import { Component, OnInit } from '@angular/core';
import { FaqsService } from './faqs.service';
import { first } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { META_TAG } from 'src/app/core/const/meta_tag';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss'],
})
export class FaqsComponent implements OnInit {
  faqs: any = [];
  selectedCatgory = null;
  fragementFaq = null;
  constructor(
    private _faqService: FaqsService,
    private route: ActivatedRoute,
    private viewportScroller: ViewportScroller,
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit() {
    this.title.setTitle(META_TAG.faq.title);

    this.meta.updateTag({
      name: 'description',
      content: META_TAG.faq.description,
    });

    this.meta.updateTag({
      name: 'og:description',
      content: META_TAG.faq.description,
    });

    this._faqService
      .getFaqs()
      .pipe(first())
      .subscribe((response: any) => {

        if (response?.data?.Faq) {

          const faqData = response.data.Faq;

          Object.keys(faqData).forEach((category) => {
            faqData[category] = faqData[category].map((faq: any) => {
              const cleaned = typeof faq.Reponse === 'string'
                ? faq.Reponse.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '').replace(/\son\w+="[^"]*"/gi, '')
                : faq.Reponse;
              return {
                ...faq,
                Reponse: cleaned
              };
            });
          });

          this.faqs = faqData;

          setTimeout(() => {
            this.route.fragment.pipe(first()).subscribe((fragment: any) => {
              this.goToFragment(fragment);
            });
          }, 500);
        }
      });
  }

  goToFragment(fragement: any) {
    if (fragement) {
      this.viewportScroller.scrollToAnchor(fragement);
    }
  }

  convertIdForAncre(text: any) {
    return text.split(' ').join('-').toLowerCase();
  }
}
